import { render, staticRenderFns } from "./EditExam.vue?vue&type=template&id=6ff85467&scoped=true&"
import script from "./EditExam.vue?vue&type=script&lang=js&"
export * from "./EditExam.vue?vue&type=script&lang=js&"
import style0 from "./EditExam.vue?vue&type=style&index=0&id=6ff85467&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff85467",
  null
  
)

export default component.exports